<template>
    <div class="skill-bar">
      <span class="skill-name">{{ name }}</span>
      <div class="bar-background">
        <div class="bar-fill" :style="{ width: level + '%' }"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SkillBar',
    props: {
      name: String,
      level: Number
    }
  }
  </script>
  
  <style scoped>
  .skill-bar {
    margin-bottom: 12px;
  }
  .skill-name {
    display: block;
    margin-bottom: 5px;
  }
  .bar-background {
  background-color: #ddd;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  max-width: 600px; /* Optional: prevent it from stretching too wide on large screens */
}
  .bar-fill {
    height: 100%;
    background-color: #FF9442;
    transition: width 0.5s ease-in-out;
  }
  </style>
  